import { GetServiceDeliveryPointOverviewForAddressResponseItem } from '@eneco/dc-be/client';

export const canUpdateMeterFrequency = (
  serviceDeliveryPoint: GetServiceDeliveryPointOverviewForAddressResponseItem,
) => {
  const hasPendingUpdate =
    serviceDeliveryPoint.invoiceFrequency.changeRequestPending ||
    serviceDeliveryPoint.meterRegime?.changeRequestPending;

  return serviceDeliveryPoint.meterType !== 'Analogue' && !hasPendingUpdate;
};
